import React from "react";
import {Checkbox} from "@renta-apps/renta-react-components";
import Localizer from "@/localization/Localizer";
import styles from "./AlertSubscriptionsManagement.module.scss";
import {AlertState} from "./AlertSubscriptionsManagement";

export interface IBaseAlertSubscriptionManagementProps {
    itemKey?: string;
    disabled: boolean;
    checked: AlertState;
    singleDevice: boolean;
    numberOfDevices?: number;
    numberOfSupportedDevices?: number;
    rowIndex: number;
    onChange: (value: boolean) => void;
}

interface IAlertSubscriptionManagementProps extends IBaseAlertSubscriptionManagementProps {
    id: string;
    label: string;
    description?: string;
    descriptionBold?: boolean;
    descriptionDataCy?: string;
    children?: React.ReactNode;
}

export const defaultComparer = (prevProps: IBaseAlertSubscriptionManagementProps, nextProps: IBaseAlertSubscriptionManagementProps) => {
    return prevProps.checked === nextProps.checked
        && prevProps.disabled === nextProps.disabled
        && prevProps.numberOfDevices === nextProps.numberOfDevices
        && prevProps.numberOfSupportedDevices === nextProps.numberOfSupportedDevices
        && prevProps.rowIndex === nextProps.rowIndex
        && prevProps.singleDevice === nextProps.singleDevice
        && prevProps.itemKey === nextProps.itemKey;
};

const AlertSubscriptionManagement: React.FC<IAlertSubscriptionManagementProps> = (props: IAlertSubscriptionManagementProps) => {
    return (
        <div className={`${styles.dataRow} ${props.rowIndex % 2 === 0 ? styles.odd : ''}`}>
            <div className={styles.checkboxCell}>
                <Checkbox id={props.itemKey ? `${props.itemKey}_${props.id}` : props.id}
                          checked={props.checked}
                          onChange={props.onChange}
                          disabled={props.disabled}
                />
            </div>
            <div className={styles.firstRow}>{props.label}</div>
            <div className={styles.additionalInfo}>
                {!props.singleDevice && (
                    <span className={styles.supportedByDevicesText}>
                        {Localizer.get(
                            Localizer.fleetMonitoringPageSubscribeToAlertsModalSupportedOfSelected,
                            props.numberOfSupportedDevices,
                            props.numberOfDevices
                        )}
                    </span>
                )}
                <div className={styles.descriptionContainer}>
                    {props.description && (
                        <span className={props.descriptionBold ? styles.descriptionBold : ''} data-cy={props.descriptionDataCy && props.itemKey ? `${props.itemKey}_${props.descriptionDataCy}` : props.descriptionDataCy}>
                        {props.description}
                    </span>
                    )}
                    {props.children}
                </div>
            </div>
        </div>
    );
};

export default AlertSubscriptionManagement;